var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMapsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925293,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925293,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4575 20.9324L36.4573 20.9923C36.4571 21.0175 36.4569 21.0427 36.4566 21.068C36.4572 21.0974 36.4575 21.1271 36.4575 21.157C36.4575 25.8581 32.7348 30.0193 30.2438 32.8039C29.5209 33.6119 28.9018 34.304 28.5074 34.8597C27.1045 36.8365 26.364 38.9781 26.1692 39.8017C26.1692 40.422 25.6457 40.9249 25 40.9249C24.3543 40.9249 23.8309 40.422 23.8309 39.8017C23.636 38.9781 22.8956 36.8365 21.4927 34.8597C21.0982 34.304 20.4791 33.6119 19.7563 32.8039C17.2652 30.0193 13.5426 25.8581 13.5426 21.157C13.5426 21.1271 13.5429 21.0974 13.5435 21.068C13.5429 21.0228 13.5426 20.9776 13.5426 20.9324C13.5426 14.8533 18.6723 9.92529 25 9.92529C31.3278 9.92529 36.4575 14.8533 36.4575 20.9324ZM25 24.9758C27.4537 24.9758 29.4427 23.0649 29.4427 20.7077C29.4427 18.3506 27.4537 16.4397 25 16.4397C22.5464 16.4397 20.5574 18.3506 20.5574 20.7077C20.5574 23.0649 22.5464 24.9758 25 24.9758Z",
    fill: "#34A851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1759 15.8719C33.7729 13.2748 31.3244 11.2829 28.3659 10.4106L21.7856 17.7641C22.5947 16.9498 23.7356 16.4424 24.9999 16.4424C27.4535 16.4424 29.4426 18.3533 29.4426 20.7105C29.4426 21.6721 29.1116 22.5594 28.553 23.2731L35.1759 15.8719Z",
    fill: "#4285F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8909 32.9527C19.847 32.9036 19.8027 32.8541 19.758 32.8042C18.116 30.9687 15.9389 28.535 14.6455 25.7429L21.4846 18.1001C20.9044 18.8213 20.5591 19.7259 20.5591 20.708C20.5591 23.0652 22.5481 24.9761 25.0017 24.9761C26.2446 24.9761 27.3683 24.4857 28.1747 23.6955L19.8909 32.9527Z",
    fill: "#F9BB0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2535 13.8228C14.5624 15.7408 13.5426 18.2225 13.5426 20.933C13.5426 20.9783 13.5429 21.0235 13.5435 21.0686C13.5429 21.098 13.5426 21.1277 13.5426 21.1577C13.5426 22.7599 13.9751 24.2995 14.6438 25.7432L21.4714 18.1133L16.2535 13.8228Z",
    fill: "#E74335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3667 10.408C27.3024 10.0942 26.1721 9.92529 25.0007 9.92529C21.4944 9.92529 18.3559 11.4384 16.2543 13.8221L21.4721 18.1127L21.4835 18.1C21.5784 17.982 21.6796 17.8689 21.7866 17.7612L28.3667 10.408Z",
    fill: "#1A73E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapsIcon);
export default __webpack_public_path__ + "static/media/googleMapsIcon.ea24321ebe89b1a26481052fc0f0fd63.svg";
export { ForwardRef as ReactComponent };